import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ScrollListener from '../../components/scroll-listener';
import scrollParent from '../../services/scroll-parent';

class LoadMore extends Component {
  shouldLoadMore = position => {
    const end = scrollParent().scrollHeight;
    return position > end && this.props.hasMore && !this.props.isLoading;
  };

  handleScroll = scroll => {
    const position = scroll.scrollTop + scroll.documentHeight + this.props.threshold;
    if (this.shouldLoadMore(position)) {
      this.loadMore();
    }
  };

  loadMore = () => {
    this.props.loadMore(this.page);
    this.page++;
  };

  componentDidMount = () => {
    this.page = this.props.pageStart;
  };

  render = () => {
    const { element: Element, children, loader, hasMore, ...props } = this.props;
    const passProps = _.omit(props, ['scroll', 'loadMore', 'isLoading', 'pageStart', 'threshold', 'dispatch']);

    return (
      <Element {...passProps}>
        {children}
        {hasMore && loader}
        <ScrollListener onScroll={this.handleScroll}/>
      </Element>
    );
  };
}

LoadMore.propTypes = {
  element: PropTypes.string,
  children: PropTypes.node,
  loader: PropTypes.node,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  pageStart: PropTypes.number,
  threshold: PropTypes.number,
};

LoadMore.defaultProps = {
  element: 'div',
  hasMore: false,
  pageStart: 2,
  threshold: 500,
};

export default LoadMore;



// WEBPACK FOOTER //
// ./app/components/load-more/load-more.js